import useSearch from "./useSearch.hook";

export default useSearch;
